import script from "./DevicesBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./DevicesBoard.vue?vue&type=script&setup=true&lang=js"

import "./DevicesBoard.vue?vue&type=style&index=0&id=127694d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-127694d4"]])

export default __exports__